// PdfComp.jsx
import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import MainLayout from '../../layouts/MainLayout';
// import pdf from "./books/1.pdf";

function PdfComp(props) {
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [error, setError] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function onError(error) {
        setError(error);
    }

    return (
        <MainLayout>
            <div className="pdf-div">
                {error && <div>Error: {error.message}</div>}
                {!error && (
                    <React.Fragment>
                        <p>
                            Page {pageNumber} of {numPages}
                        </p>
                        <Document
                            file={pdf}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onError={(error) => console.error('Error loading PDF:', error)}
                        ></Document>
                        {/* <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess} onError={onError}>
                            {Array.apply(null, Array(numPages))
                                .map((x, i) => i + 1)
                                .map((page) => {
                                    return (
                                        <Page
                                            key={page}
                                            pageNumber={page}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                        />
                                    );
                                })}
                        </Document> */}
                    </React.Fragment>
                )}
            </div>
        </MainLayout>
    );
}
export default PdfComp;

